export default {
    default: [
        {
            hoverControl: false,
            label: 'Page Title & Description',
            modules: [
                {
                    path: 'settings/meta/title',
                    content: {
                        template: 'Input',
                        label: 'Page Title',
                    },
                },
                {
                    path: 'settings/meta/description',
                    content: {
                        template: 'Input',
                        inputType: 'textarea',
                        label: 'Page Description',
                    },
                },
            ],
        },
    ],
};
